import types from '../types'

export const showSynopsis = (show) => (dispatch) => {
  dispatch({ type: types.SHOW_SYNOPSIS, payload: show })
}

export const setYears = (value) => (dispatch) => {
  dispatch({ type: types.SET_YEARS, payload: value })
}